
import React from 'react'

interface HeroV2Props {
  currentLang: 'zh' | 'en'
}

const HeroV2: React.FC<HeroV2Props> = (_props) => {
  return (
    <section className="relative h-screen min-h-[600px] w-full overflow-hidden bg-black">
      {/* Background image (fallback to high-quality coffee scene) */}
      <div className="absolute inset-0">
        <img
          src="https://file.lumi.new/p373839333138763776/SPF2016978765358108672.webp"
          alt="ONGU Studio coffee roasting"
          className="h-full w-full object-cover"
        />
        {/* Black overlay 32% — matches Barista Map mood */}
        <div className="absolute inset-0 bg-black/35" />
        {/* Top gradient — ensures white navbar legibility */}
        <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black/45 to-transparent" />
      </div>

      {/* Scroll indicator (thin vertical line, baristamap signature) */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2">
        <div className="h-16 w-px bg-gradient-to-b from-white/60 to-transparent" />
      </div>
    </section>
  )
}

export default HeroV2
